import React from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { SocialMediaShareBtn } from './SocialMediaShareBtn.jsx';
import { CssAnimation } from './CssAnimation.jsx';

export function SocialMediaShare(props) {

  const { 
    label, 
    labelSize,
    labelUnderline,
    buttons, 
    url, 
    media,
    getBlob,
    filename,
    align,
    cssAnimation,
    cssAnimationTrigger,
    cssAnimationDelay,
    gtmComponentGroup,
    gtmComponentName
  } = props;

  const block = 'c-social-media-share';

  return (
    <CssAnimation 
    enter={{ name: 'fade-in', duration: 1, delay: `${cssAnimationDelay}, hidden`, easing: 'ease-out' }} 
    triggerEnter={cssAnimationTrigger}
    disable={!cssAnimation}
    >
    <div className={`${block}__container ${block}__container--${align}`}>
    {
      label &&
        <div 
        className={classNames({
          [`${block}__label ${block}__label--${align} ${labelSize}`]: true,
          [`${block}__label--underline`]: labelUnderline
        })}
        >
          {label}
        </div>
    }
    <div className={`${block}__buttons ${block}__buttons--${align}`}>
      {
        Object.keys(buttons).map(name =>
          <SocialMediaShareBtn
          name={name}
          url={url}
          getBlob={getBlob}
          filename={filename}
          media={media}
          key={name}
          cssAnimationDelay={cssAnimationDelay}
          gtmComponentGroup={gtmComponentGroup}
          gtmComponentName={gtmComponentName}
          />
        )
      }
    </div>
  </div>
  </CssAnimation>
  )
};

SocialMediaShare.propTypes = {
  label: propTypes.string, 
  labelSize: propTypes.string,
  labelUnderline: propTypes.bool,
  buttons: propTypes.object, 
  url: propTypes.string, 
  media: propTypes.string,
  align: propTypes.string,
  cssAnimation: propTypes.bool,
  cssAnimationTrigger: propTypes.oneOfType([
    propTypes.string,
    propTypes.bool
  ]),
  cssAnimationDelay: propTypes.number,
  gtmComponentGroup: propTypes.string,
  gtmComponentName: propTypes.string
};

SocialMediaShare.defaultProps = {
  align: 'center',
  labelSize: 'caveat',
  url: window.location.href,
  cssAnimation: true,
  cssAnimationDelay: 0,
  cssAnimationTrigger: 'in-view-init'
};
